//
// Copyright 2020 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import { file_dxos_error } from "./error_pb.js";
/**
 * Describes the file dxos/rpc.proto.
 */
export const file_dxos_rpc = /*@__PURE__*/ fileDesc("Cg5keG9zL3JwYy5wcm90bxIIZHhvcy5ycGMi1gEKClJwY01lc3NhZ2USJAoHcmVxdWVzdBgBIAEoCzIRLmR4b3MucnBjLlJlcXVlc3RIABImCghyZXNwb25zZRgCIAEoCzISLmR4b3MucnBjLlJlc3BvbnNlSAASDgoEb3BlbhgDIAEoCEgAEhIKCG9wZW5fYWNrGAQgASgISAASLQoMc3RyZWFtX2Nsb3NlGAUgASgLMhUuZHhvcy5ycGMuU3RyZWFtQ2xvc2VIABIcCgNieWUYBiABKAsyDS5keG9zLnJwYy5CeWVIAEIJCgdjb250ZW50IksKDFRyYWNlQ29udGV4dBITCgt0cmFjZXBhcmVudBgBIAEoCRIXCgp0cmFjZXN0YXRlGAIgASgJSACIAQFCDQoLX3RyYWNlc3RhdGUiogEKB1JlcXVlc3QSCgoCaWQYASABKAUSDgoGbWV0aG9kGAIgASgJEiUKB3BheWxvYWQYAyABKAsyFC5nb29nbGUucHJvdG9idWYuQW55Eg4KBnN0cmVhbRgEIAEoCBIyCg10cmFjZV9jb250ZXh0GAUgASgLMhYuZHhvcy5ycGMuVHJhY2VDb250ZXh0SACIAQFCEAoOX3RyYWNlX2NvbnRleHQilwEKCFJlc3BvbnNlEgoKAmlkGAEgASgFEicKB3BheWxvYWQYAiABKAsyFC5nb29nbGUucHJvdG9idWYuQW55SAASIgoFZXJyb3IYAyABKAsyES5keG9zLmVycm9yLkVycm9ySAASDwoFY2xvc2UYBCABKAhIABIWCgxzdHJlYW1fcmVhZHkYBSABKAhIAEIJCgdjb250ZW50IhkKC1N0cmVhbUNsb3NlEgoKAmlkGAEgASgFInoKDE1lc3NhZ2VUcmFjZRIzCglkaXJlY3Rpb24YASABKA4yIC5keG9zLnJwYy5NZXNzYWdlVHJhY2UuRGlyZWN0aW9uEgwKBGRhdGEYAiABKAwiJwoJRGlyZWN0aW9uEgwKCElOQ09NSU5HEAASDAoIT1VUR09JTkcQASIFCgNCeWVCKVonZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvcnBjYgZwcm90bzM", [file_google_protobuf_any, file_dxos_error]);
/**
 * Describes the message dxos.rpc.RpcMessage.
 * Use `create(RpcMessageSchema)` to create a new message.
 */
export const RpcMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 0);
/**
 * Describes the message dxos.rpc.TraceContext.
 * Use `create(TraceContextSchema)` to create a new message.
 */
export const TraceContextSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 1);
/**
 * Describes the message dxos.rpc.Request.
 * Use `create(RequestSchema)` to create a new message.
 */
export const RequestSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 2);
/**
 * Describes the message dxos.rpc.Response.
 * Use `create(ResponseSchema)` to create a new message.
 */
export const ResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 3);
/**
 * Describes the message dxos.rpc.StreamClose.
 * Use `create(StreamCloseSchema)` to create a new message.
 */
export const StreamCloseSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 4);
/**
 * Describes the message dxos.rpc.MessageTrace.
 * Use `create(MessageTraceSchema)` to create a new message.
 */
export const MessageTraceSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 5);
/**
 * @generated from enum dxos.rpc.MessageTrace.Direction
 */
export var MessageTrace_Direction;
(function (MessageTrace_Direction) {
    /**
     * @generated from enum value: INCOMING = 0;
     */
    MessageTrace_Direction[MessageTrace_Direction["INCOMING"] = 0] = "INCOMING";
    /**
     * @generated from enum value: OUTGOING = 1;
     */
    MessageTrace_Direction[MessageTrace_Direction["OUTGOING"] = 1] = "OUTGOING";
})(MessageTrace_Direction || (MessageTrace_Direction = {}));
/**
 * Describes the enum dxos.rpc.MessageTrace.Direction.
 */
export const MessageTrace_DirectionSchema = /*@__PURE__*/ enumDesc(file_dxos_rpc, 5, 0);
/**
 * Describes the message dxos.rpc.Bye.
 * Use `create(ByeSchema)` to create a new message.
 */
export const ByeSchema = /*@__PURE__*/ messageDesc(file_dxos_rpc, 6);
//# sourceMappingURL=rpc_pb.js.map